import { GetHeader, CacheHeader } from '../common'
const URL = process.env.REACT_APP_API_NOTICE!

//003 お知らせ情報取得(認証無)
export const getNotice = async (): Promise<string> => {
  const header = CacheHeader()
  const res = await fetch(`${URL}/notice`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => res.noticetext)
  //const res = fetch(URL).then(response => text).then(res => res.noticetext)
  return res
}

//004 お知らせ情報取得(認証有)
export const getAuthNotice = async (userid: string, token: string, role: string): Promise<string> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/notice/${userid}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => res.noticetext)
  return res
}